import { GroupMember, GroupRole } from '@ih/app/shared/apis/interfaces';

export class FindAllGroupRoles {
  public static readonly type = '[Group/Users/List] FindAllGroupRoles';
  constructor(
    public readonly groupMembers: GroupMember[],
    public readonly defaultRoles: GroupRole[],
  ) {}
}
